<template>
  <div class="checkbox-wrapper">
    <div class="checkbox-content">
      <!-- 可选按钮展示 -->
      <div class="checkbox-info">
        <div
          class="checkbox-info-wrapper"
          v-for="(item, index) in checkedInfo"
          :key="index"
        >
          <el-checkbox-button
            :label="item.key || item.skuCode"
            v-model="item.checked"
            :disabled="isDetailPage"
          >
            {{ item.value || item.skuName }}
          </el-checkbox-button>
          <!-- 自定义的checkbox 可删除 -->
          <div
            v-if="item.allowDelete && !isDetailPage"
            class="delete-btn"
            @click="handleDeleteCheckbox(index, item)"
          >
            <i class="el-icon-error"></i>
          </div>
        </div>

        <!-- 添加选项 -->
        <div class="add" v-if="showAdd && !isDetailPage">
          <i class="el-icon-circle-plus" @click="handleShowDialog()"></i>
        </div>
      </div>

      <!-- 是否全选 -->
      <div
        style="width:80px;padding-right:20px"
        class="checkbox-operating"
        v-if="!isDetailPage"
      >
        <el-checkbox-button v-model="checkAll" @change="handleCheckAllChange">{{
          checkAll ? "取消全选" : "全选"
        }}</el-checkbox-button>
      </div>

      <!-- 是否重置 -->
      <div
        style="text-align: right"
        class="checkbox-operating"
        v-if="!isDetailPage"
      >
        <el-button size="mini" type="warning" @click="handleReset"
          >重置</el-button
        >
      </div>
    </div>

    <!-- 新增堆箱规格弹窗 -->
    <el-dialog
      class="dialog"
      title="新增堆箱规格"
      :close-on-click-modal="false"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <!-- <span>这是一段信息</span> -->
      <div class="content" v-for="(item, index) in inputLine" :key="index">
        <div class="input-wrapper">
          <el-input
            v-model="inputLine[index].row"
            placeholder="请输入行数"
            @input="checkInput($event, index, 'row')"
          ></el-input>
        </div>
        <div>X</div>
        <div class="input-wrapper">
          <el-input
            v-model="inputLine[index].col"
            placeholder="请输入列数"
            @input="checkInput($event, index, 'col')"
          ></el-input>
        </div>
        <div class="input-operate">
          <el-button size="mini" @click="handleAddLine">新 增</el-button>
          <el-button
            size="mini"
            type="danger"
            class="input-delete"
            v-if="inputLine.length > 1"
            @click="handleDeleteLine(index)"
            >删 除</el-button
          >
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="handleConfirmAddLine">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 新增多选赠酒sku -->
    <el-dialog
      class="select-dialog"
      title="新增赠酒SKU"
      :close-on-click-modal="false"
      :show-close="true"
      :visible.sync="dialogBeerVisible"
      width="800px"
    >
      <!-- 筛选条件 -->
      <div>
        <el-row>
          <el-col :span="24">
            <el-form
              class="dialog-form"
              ref="beer-form"
              :model="beerParams"
              :inline="true"
              label-width="100px"
            >
              <el-form-item label="SKU编码" prop="skuCode">
                <el-input
                  v-model="beerParams.skuCode"
                  placeholder="请输入SKU编码"
                />
              </el-form-item>
              <el-form-item label="SKU名称" prop="skuName">
                <el-input
                  v-model="beerParams.skuName"
                  placeholder="请输入SKU名称"
                />
              </el-form-item>
              <span>
                <el-button
                  class="btn btn-red"
                  size="small"
                  @click="getBeerList()"
                  >搜索</el-button
                >
                <el-button
                  class="btn btn-reset"
                  size="small"
                  @click="resetSearch()"
                  >重置</el-button
                >
              </span>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <el-table
        class="dialog-table"
        v-loading="beerLoading"
        ref="beerTable"
        :data="beerList"
        style="width: 100%;margin:20px 0;"
        :header-row-style="{ lineHeight: '30px' }"
        border
        :row-key="beerRowKey"
        @select="getSelectBeer"
        @select-all="selectAllBeer"
      >
        <el-table-column
          width="150"
          align="center"
          prop="skuCode"
          label="SKU编码"
        />
        <el-table-column align="center" prop="skuName" label="SKU名称" />
        <el-table-column
          align="center"
          type="selection"
          :reserve-selection="true"
          width="150"
        />
      </el-table>
      <el-row class="while-data-table-footer">
        <el-col>
          <el-pagination
            background
            :current-page="beerParams.page"
            :page-size="beerParams.pageSize"
            :total="total"
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
          />
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogBeerVisible = false">取 消</el-button>
        <el-button type="danger" @click="handleAddBeer">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  // 按钮方式多选 组件
  name: 'perfect-theme-checkbox',
  props: {
    employeeLevel: {
      type: [String, Number],
      default: ''
    },
    // 费用返还:bonusType   赠酒sku:bonusBeer  陈列追踪:trackType  单品牌堆箱规格:stackSize
    commonKey: {
      type: String,
      default: ''
    },
    // 用以展示的原始数据
    originInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 用以匹配的用户选择的数据
    matchInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showAdd: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      beerLoading: false,
      pageType: '',
      class: '',
      checkedInfo: [],
      originData: [],
      checkAll: null,
      dialogBeerVisible: false,
      dialogVisible: false,
      inputLine: [{ row: '', col: '', scope: '' }],
      seletcedBeerList: [],
      checkedResult: true,
      beerList: [],
      total: 0,
      beerParams: {
        page: 1,
        pageSize: 10,
        skuCode: '',
        skuName: ''
      }
    }
  },
  computed: {
    isDetailPage () {
      return this.class === 'detail'
    }
  },
  watch: {
    checkedInfo: {
      deep: true,
      immediate: true,
      handler (val) {
        // 处理全选逻辑
        this.checkAll = this.checkedInfo.every(item => {
          return item.checked === true
        })

        // 处理费用返还方式与赠酒sku、陈列费、赠酒箱数显示与否联动
        if (this.commonKey === 'bonusType') {
          let arr = this.checkedInfo
          let checked01
          let checked02
          let checked03
          for (let i = 0; i < arr.length; i++) {
            if (arr[i].key === '01') {
              checked01 = arr[i].checked
            }
            if (arr[i].key === '02') {
              checked02 = arr[i].checked
            }
            if (arr[i].key === '03') {
              checked03 = arr[i].checked
            }
          }
          let obj = {
            // 线上/线下现金返还
            hasBonusFeeType: checked01 || checked02,
            // 免费酒线下返回
            hasBonusBeerType: checked03
          }
          this.$emit('change', obj)
        }
      }
    }
  },
  created () {
    this.pageType = this.$route.query.handleType
    this.class = this.$route.query.class
    if (this.commonKey === 'bonusBeer') {
      this.getBeerList()
    }
  },
  methods: {
    setData () {
      let keyArr
      let valueArr
      let arr = []
      // --------------------------------------------//
      if (this.commonKey === 'bonusBeer') {
        // 赠酒sku:bonusBeer
        // arr = JSON.parse(this.originInfo['bonusBeerScope'] || '[]')

        let matchArr = []
        keyArr = JSON.parse(this.originInfo.bonusBeerScope || '[]')
        valueArr = JSON.parse(this.originInfo.bonusBeerScope || '[]')
        matchArr = JSON.parse(this.matchInfo.bonusBeerScope || '[]')

        // 上级配置的bonusBeerScope 为默认的赠酒SKU
        for (let i = 0; i < keyArr.length; i++) {
          arr.push({
            skuCode: keyArr[i].skuCode,
            skuName: valueArr[i].skuName
          })
        }

        // matchInfo 多出来的bonusBeerScope 为自定义的赠酒SKU
        let addArr = []
        addArr = matchArr.filter(matchItem => {
          let originArr = valueArr.map(originItem => originItem.skuCode)
          return !originArr.includes(matchItem.skuCode)
        })

        if (addArr.length) {
          addArr.forEach(newItem => {
            // 添加到页面
            arr.push({
              skuCode: newItem.skuCode,
              skuName: newItem.skuName,
              allowDelete: true
            })
          })

          // 添加到已选选项列表
          this.seletcedBeerList = Object.assign([], addArr)
        }

        // --------------------------------------------//
      } else if (this.commonKey === 'stackSize') {
        // // 单品牌堆箱规格:stackSize
        // keyArr = this.originInfo[`${this.commonKey}Scope`]
        //   ? this.originInfo[`${this.commonKey}Scope`].split(',')
        //   : []
        // valueArr = this.originInfo[`${this.commonKey}Scope`]
        //   ? this.originInfo[`${this.commonKey}Scope`].split(',')
        //   : []
        // let matchArr = this.matchInfo[`${this.commonKey}Scope`]
        //   ? this.matchInfo[`${this.commonKey}Scope`].split(',')
        //   : []

        // // 上级配置的stackSize 为默认stackSize
        // for (let i = 0; i < keyArr.length; i++) {
        //   arr.push({
        //     key: keyArr[i],
        //     value: valueArr[i]
        //   })
        // }

        // // matchInfo 多出来的stackSize 为自定义的堆箱规格
        // if (matchArr.length) {
        //   matchArr.forEach(matchItem => {
        //     if (!valueArr.includes(matchItem)) {
        //       arr.push({
        //         key: matchItem,
        //         value: matchItem,
        //         allowDelete: true
        //       })
        //     }
        //   })
        // }
        let stackPackList
        stackPackList = this.originInfo.stackPackScopeList || []
        // 处理BU新增单品牌堆箱规格，导致总部数据中没有该规格的情况
        if (this.pageType === 'update' && this.employeeLevel > 50) {
          if (this.matchInfo.stackPackScopeList) {
            this.matchInfo.stackPackScopeList.forEach(item => {
              if (item.standardFlag === '0') stackPackList.push(item)
            })
          }
        }
        stackPackList.forEach(item => {
          let obj = Object.assign({}, item, {
            key: item.stackPackSize,
            value: item.stackPackSize,
            allowDelete: item.standardFlag === '0' && this.employeeLevel > 50 // 是否标准配置 1是 0否
          })
          arr.push(obj)
        })
        // --------------------------------------------//
      } else {
        keyArr = this.originInfo[`${this.commonKey}Scope`]
          ? this.originInfo[`${this.commonKey}Scope`].split(',')
          : []
        valueArr = this.originInfo[`${this.commonKey}NameScope`]
          ? this.originInfo[`${this.commonKey}NameScope`].split(',')
          : []
        for (let i = 0; i < keyArr.length; i++) {
          arr.push({
            key: keyArr[i],
            value: valueArr[i]
          })
        }
      }

      // 配置页面显示选项
      this.checkedInfo = arr
      this.initChecked()
    },

    // 初始化选项
    initChecked () {
      this.checkedInfo.map(item => {
        this.$set(item, 'checked', false)
      })

      // 修改
      if (this.pageType === 'update') {
        // 用户已勾选的数据
        let checkedScopeArr = []
        // --------------------------------------------//
        // 赠酒sku
        if (this.commonKey === 'bonusBeer') {
          checkedScopeArr = JSON.parse(
            this.matchInfo.bonusBeerScope || '[]'
          )

          if (this.checkedInfo.length && checkedScopeArr.length) {
            this.checkedInfo.forEach(origin => {
              checkedScopeArr.forEach(match => {
                if (match.skuCode === origin.skuCode) {
                  origin.checked = true
                }
              })
            })
          }
        } else if (this.commonKey === 'stackSize') {
          // 单品牌堆箱规格
          checkedScopeArr = this.matchInfo.stackPackScopeList || []
          if (this.checkedInfo.length) {
            checkedScopeArr.forEach(item => {
              this.checkedInfo.forEach(origin => {
                if (item.scopeDefineId === origin.scopeDefineId) origin.checked = true
              })
            })
          }
        } else {
          // --------------------------------------------//
          // 其他
          checkedScopeArr = this.matchInfo[`${this.commonKey}Scope`]
            ? this.matchInfo[`${this.commonKey}Scope`].split(',')
            : []

          if (this.checkedInfo.length) {
            this.checkedInfo.forEach(origin => {
              if (checkedScopeArr.indexOf(origin.key) !== -1) {
                origin.checked = true
              } else {
                origin.checked = false
              }
            })
          }
        }
      }
    },

    // 页面上全选
    handleCheckAllChange (val) {
      if (this.checkedInfo.length) {
        this.checkedInfo.forEach(item => {
          item.checked = val
        })
      }
    },

    // 页面上重置
    handleReset () {
      this.initChecked()
    },

    // 堆箱规格 新增一行输入框
    handleAddLine () {
      this.inputLine.push({
        row: '',
        col: '',
        scope: ''
      })
    },

    // 堆箱规格 删除一行输入框
    handleDeleteLine (index) {
      this.inputLine.splice(index, 1)
    },

    // 堆箱规格 输入框输入数据格式化 以及数据重复校验
    checkInput (e, index, type) {
      let value = e.replace(/[^\d]/g, '')
      let line = this.inputLine[index]
      line[type] = value
      line.scope = ''
      line.scope = `${line.row}*${line.col}`
    },

    // 堆箱规格 校验新增
    checkLine () {
      let checkFlag = true
      if (this.inputLine.length) {
        for (let i = 0; i < this.inputLine.length; i++) {
          // 校验为空
          if (!this.inputLine[i].row || !this.inputLine[i].col) {
            this.$message.warning('请补全数据')
            checkFlag = false
            break
          }
          // 校验自身重复
          for (let j = i + 1; j < this.inputLine.length; j++) {
            if (
              this.inputLine[i].scope &&
              this.inputLine[i].scope === this.inputLine[j].scope
            ) {
              this.$message.warning('填写内容已存在相同的数据')
              checkFlag = false
              break
            }
          }
          // 校验与已有列表重复
          for (let x = 0; x < this.checkedInfo.length; x++) {
            if (this.inputLine[i].scope === this.checkedInfo[x].value) {
              this.$message.warning('可选列表已存在相同数据')
              checkFlag = false
              break
            }
          }
        }
      }
      return checkFlag
    },

    // 堆箱规格 确认新增
    handleConfirmAddLine () {
      if (!this.checkLine()) {
        return
      }
      if (this.inputLine.length) {
        this.inputLine.forEach(item => {
          this.checkedInfo.push({
            checked: true,
            allowDelete: true,
            key: item.scope,
            value: item.scope
          })
        })
      }

      this.inputLine = this.$options.data().inputLine
      this.dialogVisible = false
      this.$emit('addNew', this.checkedInfo)
    },

    // 获取赠酒SKU列表
    getBeerList () {
      this.beerLoading = true
      this.$store
        .dispatch('getBeerSkuList', this.beerParams)
        .then(res => {
          this.beerLoading = false
          if (res.data.resultCode === '0') {
            this.total = res.data.resultData.pageInfo.totalCounts
            this.beerList = res.data.resultData.beerSkuList || []
            // let list = res.data.resultData.beerSkuList || []

            // let beerArr = []
            // if (list.length) {
            //   beerArr = list.map(item => {
            //     return { skuCode: item.skuCode, skuName: item.skuName }
            //   })
            // }
            // this.beerList = beerArr

            this.showBeerSelected()
          }
        })
        .catch(() => {
          this.beerLoading = false
        })
    },

    // 重置筛选条件
    resetSearch () {
      this.beerParams = this.$options.data().beerParams
      this.getBeerList()
    },

    // 选择赠酒SKU
    getSelectBeer (selectList, row) {
      const codeArr = this.seletcedBeerList.map(item => item.skuCode)

      if (codeArr.indexOf(row.skuCode) === -1) {
        this.seletcedBeerList.push(row)
        return
      }
      this.seletcedBeerList.forEach((item, index) => {
        if (item.skuCode === row.skuCode) {
          this.seletcedBeerList.splice(index, 1)
        }
      })
    },

    // 赠酒sku全选
    selectAllBeer (selectList) {
      this.seletcedBeerList = Object.assign([], selectList)
    },

    // 展示弹框
    handleShowDialog () {
      if (this.commonKey === 'stackSize') {
        this.dialogVisible = true
      } else if (this.commonKey === 'bonusBeer') {
        this.dialogBeerVisible = true
        if (this.seletcedBeerList.length && this.beerList.length) {
          this.showBeerSelected()
        }
      } else {
        this.$message.warning('该功能暂未开放')
      }
    },

    // 已勾选 表格对应展示
    showBeerSelected () {
      this.$nextTick(() => {
        this.seletcedBeerList.forEach(selectedItem => {
          this.beerList.forEach(item => {
            if (selectedItem.skuCode === item.skuCode) {
              this.$refs.beerTable.toggleRowSelection(item, true)
            }
          })
        })
      })
    },

    // 删除选项
    handleDeleteCheckbox (index, item) {
      if (this.commonKey === 'stackSize') {
        this.$emit('addNew', this.checkedInfo)
      } else if (this.commonKey === 'bonusBeer') {
        // 获取删除选项在 seletcedBeerList 中对应的对象
        let arr = this.seletcedBeerList.filter(selectedItem => {
          return item.skuCode === selectedItem.skuCode
        })
        let selectedIndex = this.seletcedBeerList.indexOf(arr[0])

        // 表格中删除
        if (this.$refs.beerTable) {
          this.$refs.beerTable.toggleRowSelection(arr[0], false)
        }
        // 选项列表中删除
        this.seletcedBeerList.splice(selectedIndex, 1)
      }
      // 页面中删除
      this.checkedInfo.splice(index, 1)
    },

    // 赠酒SKU分页
    handleCurrentChange (val) {
      this.beerParams.page = val
      this.getBeerList()
    },

    // 每行标志位
    beerRowKey (row) {
      return row.skuCode
    },

    // 新增赠酒SKU
    handleAddBeer () {
      let addList = []
      let deleteList = []

      // seletcedBeerList里有，checkedInfo里没有的元素  需新增
      addList = this.seletcedBeerList.filter(selectedItem => {
        let checkedArr = this.checkedInfo.map(
          checkedItem => checkedItem.skuCode
        )
        return !checkedArr.includes(selectedItem.skuCode)
      })

      // checkedInfo里自定义有的，seletcedBeerList里没有的  需删除
      deleteList = this.checkedInfo.filter(checkedItem => {
        let selectedArr = this.seletcedBeerList.map(
          selectedItem => selectedItem.skuCode
        )
        return (
          !selectedArr.includes(checkedItem.skuCode) && checkedItem.allowDelete
        )
      })

      // 将checkedInfo没有的,selectedBeerList新增的box添加
      if (addList.length) {
        addList.map(item => {
          this.checkedInfo.push({
            checked: true,
            allowDelete: true,
            skuCode: item.skuCode,
            skuName: item.skuName
          })
        })
      }

      // 将selectedBeerList里没有的box,从checkedInfo里删除
      if (deleteList.length) {
        deleteList.forEach(item => {
          let index = this.checkedInfo.indexOf(item)
          this.checkedInfo.splice(index, 1)
        })
      }

      console.log(this.checkedInfo)

      this.dialogBeerVisible = false
    },

    // 数据检查
    checkData () {
      this.checkedResult = true
      let checkedResult = false
      if (this.checkedInfo.length) {
        this.checkedInfo.forEach(item => {
          if (item.checked) checkedResult = true
        })
      }
      this.checkedResult = checkedResult
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox-wrapper {
  width: 100%;
  padding: 10px 0;
  background-color: #fff;
  .checkbox-info-wrapper {
    display: inline-block;
    position: relative;
    .delete-btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 10px;
      top: -5px;
      color: rgb(234, 84, 4);
      font-size: 16px;
      line-height: 20px;
      cursor: pointer;
      z-index: 999;
      text-align: center;
    }
  }
  .checkbox-content {
    display: flex;
    justify-content: flex-start;
    line-height: 50px;
    color: #333;
    transition: height 0.5s;
    .checkbox-info {
      flex-basis: 80%;
    }
    .add {
      display: inline-block;
      color: #56b0ff;
      font-size: 20px;
      cursor: pointer;
    }
    .checkbox-operating {
      flex: none;
      flex-basis: 8%;
      margin: auto;
    }
  }
  .dialog {
    .content {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .input-wrapper {
        width: 30%;
        text-align: center;
      }
    }
  }

  .select-dialog {
    .dialog-form {
      line-height: 1;
      .btn {
        margin-top: 3px;
      }
    }
    .dialog-table {
      ::v-deep .el-table__header-wrapper .el-checkbox__input::after {
        content: "全选";
        position: absolute;
        margin: 5px 0 0 10px;
        font-weight: 700;
        color: rgb(144, 147, 153);
      }
    }
  }
}
</style>
